import React, { useCallback, useEffect, useState } from "react";
import {
    Col,
    Row,
    Table,
    Collapse,
} from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import styles from "./dangKyKcb.module.css";
import { useLocation } from "react-router-dom";
import "react-image-gallery/styles/css/image-gallery.css";
import Login from "../../components/Login/login";
import ViewCdha from "../../components/ViewCdha/ViewCdha";
import { kcbService } from "../../services/kcbService";
import Loading from "../../components/common/Loading/Loading";
import PatientInfo from "../../components/common/PatientInfo/PatientInfo";
import CustomSelect from "../../components/common/CustomSelect/CustomSelect";
import Label from "../../components/common/Label/Label";


const DangKyKcb = () => {
    const [loading, setLoading] = useState(true);
    const [luotKham, setLuotKham] = useState([]);
    const [data, setData] = useState(
        {
            hoTen: "",
            ngaySinh: "",
            benhVien: "",
            chanDoan: "",
        }
    );
    const [cdha, setCdha] = useState([]);
    const [xn, setXn] = useState([]);
    const [thuoc, setThuoc] = useState([]);
    const [isLogin, setIsLogin] = useState(false);
    const { search } = useLocation();
    const makcb = new URLSearchParams(search).get("makcb");
    const mandk = new URLSearchParams(search).get("mandk");
    localStorage.setItem("makcb", makcb)
    const [selectedMaKcb, setSelectedMaKcb] = useState(null);

    const handleChange = useCallback((value) => {
        setSelectedMaKcb(value);

        const selectedLuotKham = kcbService.getLuotKhamById(luotKham, value);
        if (selectedLuotKham) {
            setCdha(kcbService.filterCdha(selectedLuotKham.canLamSangDto));
            setXn(kcbService.filterXetNghiem(selectedLuotKham.canLamSangDto));
            setThuoc(selectedLuotKham.thuocDto);
            setData(selectedLuotKham);
        }
    }, [luotKham]);

    // Set mặc định khi luotKham có dữ liệu (ví dụ chọn phần tử đầu tiên)
    useEffect(() => {
        if (luotKham?.length > 0) {
            handleChange(makcb);
        }
    }, [handleChange, luotKham, makcb]);

    useEffect(() => {
        const fetchData = async () => {
            if (!makcb || !mandk || !isLogin) {
                setLoading(false);
                return;
            }

            setLoading(true);
            try {
                const result = await kcbService.getLichSuKCB(makcb, mandk);
                setData(result.data[0]);
                setLuotKham(result.data);
            } catch (error) {
                console.error("Lỗi tải dữ liệu:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [makcb, mandk, isLogin]);

    if (loading) {
        return <Loading tip="Đang tải dữ liệu..." fullScreen={true} />;
    }

    const columnsThuoc = [
        {
            title: <span style={{ color: "#219737", fontWeight: "bold" }}>Tên thuốc</span>,
            key: 'tenThuoc',
            dataIndex: 'tenThuoc',
        },
        {
            title: 'ĐVT',
            key: 'tenDonViTinh',
            dataIndex: 'tenDonViTinh',
            width: 50
        },
        {
            title: 'S.L',
            key: 'soLuong',
            dataIndex: 'soLuong',
            width: 50
        },
    ];

    return (
        <Row justify="center" style={{ padding: "16px 0px 0" }}>
            <Col xs={24} sm={22} md={20} lg={16} xl={14}>
                {/* Login */}
                {!isLogin && <Login setIsLogin={setIsLogin}></Login>}

                {/* Thông tin bệnh nhân */}
                {isLogin && (
                    <>
                        <div className={styles.wrapSelectSection}>
                            <PatientInfo
                                data={data}
                            />
                            <div className={styles.selectSection}>
                                <Label>
                                    Lượt khám bệnh
                                </Label>
                                <CustomSelect
                                    value={selectedMaKcb}
                                    onChange={handleChange}
                                    className={styles.visitSelect}
                                    options={luotKham?.map((m, i) => ({
                                        value: m.maKcb,
                                        label: `Lần ${luotKham.length - i}: [${m.ngayDk}] - ${m.maKcb}`
                                    }))}
                                    placeholder="Chọn lượt khám cần xem"
                                />
                            </div>
                            {/* Thông tin thuốc vật tư - dịch vụ*/}
                            {cdha && cdha.length > 0 && (
                                <>
                                    <div className={styles.selectSection}>
                                        <Label>
                                            Chẩn đoán hình ảnh
                                        </Label>
                                        <Collapse accordion items={cdha.map((m) => ({
                                            key: m.externId,
                                            label: <div className={styles.collapseLabel}>
                                                <span>{m.tenDichVu}</span>
                                                <div className={styles.labelRight}>
                                                    {m.ngayKq && <span className={styles.dateText}>{m.ngayKq}</span>}
                                                    {m.ngayKq && <CheckCircleOutlined className={styles.checkIcon} />}
                                                </div>
                                            </div>,
                                            children: <ViewCdha externId={m.externId} />
                                        }))} />
                                    </div>
                                </>
                            )}

                            {xn && xn.length > 0 && (
                                <>
                                    <div className={styles.selectSection}>
                                        <Label>
                                            Xét nghiệm
                                        </Label>
                                        <Collapse accordion items={xn.map((m) => ({
                                            key: m.externId,
                                            label: <div className={styles.collapseLabel}>
                                                <span>{m.tenDichVu}</span>
                                                <div className={styles.labelRight}>
                                                    {m.ngayKq && <span className={styles.dateText}>{m.ngayKq}</span>}
                                                    {m.ngayKq && <CheckCircleOutlined className={styles.checkIcon} />}
                                                </div>
                                            </div>,
                                            children: <ViewCdha externId={m.externId} />
                                        }))} />
                                    </div>
                                </>
                            )}

                            {thuoc && thuoc.length > 0 && (
                                <Table
                                    className={"medicineTable"}
                                    columns={columnsThuoc}
                                    dataSource={thuoc}
                                    pagination={false}
                                />
                            )}
                        </div>
                    </>
                )}
            </Col>
        </Row>
    );
};

export default DangKyKcb;
